'use client';

import type { ExerciseVisualBlock } from '@jeraisonne/ai/visual-blocks';
import { VisualBlockRenderer } from './visual-block-renderer';

/**
 * Types « larges » : tableaux, code et vidéos restent en pleine largeur même en
 * grille desktop (illisibles dans une demi-colonne). Tout le reste (figures math,
 * images) sont « compacts » et se rangent côte à côte sur grand écran.
 */
const WIDE_TYPES = new Set<ExerciseVisualBlock['type']>([
  'table',
  'python_code',
  'scratch_code',
  'video_upload',
  'youtube_embed',
]);

export function VisualBlocksRenderer({ blocks }: { blocks: ExerciseVisualBlock[] }) {
  if (!blocks.length) return null;

  const sorted = [...blocks].sort((a, b) => a.order - b.order);

  // Un seul visuel → pleine largeur, pas de grille.
  const [first] = sorted;
  if (sorted.length === 1 && first) {
    return <VisualBlockRenderer block={first} />;
  }

  // Plusieurs visuels → mobile : empilés (1 colonne) ; desktop : 2 colonnes pour
  // exploiter la largeur et comparer les figures (ex. « Graphique a/b/c/d »).
  // Les visuels larges (tableaux, code) reprennent toute la largeur.
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {sorted.map((block) => (
        <VisualBlockRenderer
          key={block.id}
          block={block}
          className={WIDE_TYPES.has(block.type) ? 'sm:col-span-2' : undefined}
        />
      ))}
    </div>
  );
}
